import React, { useState } from 'react';
import type { ButtonType } from '@/components/custom/erp/input-table-v2';
import { getInputTableColumns } from '../../cols-definition';
import { EditPrintTemplateTableType } from '../../schemas';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

const ACTION_ORDER: ButtonType[] = ['add', 'delete', 'copy', 'paste', 'moveUp', 'moveDown', 'export', 'pin'];
const noop = () => {};

function ColumnPrintTab() {
  const [formMode] = useState<FormMode>('view');
  const [rows] = useState<EditPrintTemplateTableType[]>([]);
  const [selectedRowId, setSelectedRowId] = useState<string>('');

  const handleRowClick = (params: { id: string; row: EditPrintTemplateTableType }) => {
    setSelectedRowId(params.id || (params.row as BanHangRecord)?.id || '');
  };

  return (
    <ErpInputTableV2<EditPrintTemplateTableType>
      rows={rows}
      columns={getInputTableColumns()}
      selectedRowId={selectedRowId}
      onRowClick={handleRowClick}
      getRowId={row => (row as BanHangRecord)?.id || ''}
      actionsDisabled={formMode === 'view'}
      actionOrder={ACTION_ORDER}
      actions={{
        add: noop,
        delete: noop,
        copy: noop,
        paste: noop,
        moveUp: noop,
        moveDown: noop,
        export: noop,
        pin: noop
      }}
    />
  );
}

export default ColumnPrintTab;
